/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100ForbiddenException } from './Ptw100ForbiddenException';
import {
    Ptw100ForbiddenExceptionFromJSON,
    Ptw100ForbiddenExceptionFromJSONTyped,
    Ptw100ForbiddenExceptionToJSON,
} from './Ptw100ForbiddenException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100ForbiddenException
 */
export interface ErrorResponseOfPtw100ForbiddenException {
    /**
     * This code is used in the ExceptionMiddleware and will be set as the HTTP response status code
     * @type {number}
     * @memberof ErrorResponseOfPtw100ForbiddenException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100ForbiddenException}
     * @memberof ErrorResponseOfPtw100ForbiddenException
     */
    exception: Ptw100ForbiddenException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100ForbiddenException
     */
    $type?: ErrorResponseOfPtw100ForbiddenExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100ForbiddenExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroCoreSharedExceptionsPtw100ForbiddenExceptionPtwPtw100AppZeroCoreSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100ForbiddenException, Ptw.Ptw100.AppZero.Core.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100ForbiddenExceptionTypeEnum = typeof ErrorResponseOfPtw100ForbiddenExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100ForbiddenExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100ForbiddenException interface.
 */
export function instanceOfErrorResponseOfPtw100ForbiddenException(value?: unknown): value is ErrorResponseOfPtw100ForbiddenException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100ForbiddenExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100ForbiddenExceptionFromJSON(json: any): ErrorResponseOfPtw100ForbiddenException {
    return ErrorResponseOfPtw100ForbiddenExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100ForbiddenExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100ForbiddenException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100ForbiddenExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100ForbiddenExceptionToJSON(value?: Omit<ErrorResponseOfPtw100ForbiddenException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100ForbiddenExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

